import baseAPI from '@/http'

const router = 'api/relatorio'

export const ReportAPIPublic = {
  getById: (id) => baseAPI.get(`${router}` + '/get-by-id' + `/${id}`),
  downloadAnexo: (relatorioAnexoId) => baseAPI.post('api/arquivo/anexo/download/' + relatorioAnexoId, null, { responseType: 'blob' }),

}
